var map = {
	"../details/details.module.ngfactory": [
		"s5mu",
		2,
		0,
		9
	],
	"../events/events.module.ngfactory": [
		"pkyO",
		0,
		8
	],
	"../payment/payment.module.ngfactory": [
		"9DpL",
		0,
		7
	],
	"../review/review.module.ngfactory": [
		"Mxbm",
		0,
		6
	],
	"../tickets/tickets.module.ngfactory": [
		"uUcz",
		2,
		0,
		11
	],
	"./shop/shop.module.ngfactory": [
		"g+Zp",
		2,
		0,
		10
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;